// src/App.js
import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate
} from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Container } from '@mui/material';

import UserDashboard from './components/Dashboard/UserDashboard';
import ConsultaEnvio from './components/ConsultaEnvio';
import Login from './components/Login';
import CrearCasillero from './components/CrearCasillero';
import CreateAdmin from './components/CreateAdmin';
import Home from './components/Home';

import { validateToken, logout } from './services/authService';

function App() {
  const [rol, setRol] = useState(localStorage.getItem('rol'));
  const [correo, setCorreo] = useState(localStorage.getItem('correo'));
  const [casilleroCodigo, setCasilleroCodigo] = useState(localStorage.getItem('casilleroCodigo'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoading(false);
      return;
    }

    const validarSesion = async () => {
      try {
        const res = await validateToken();

        setRol(res.usuario?.rol);
        setCorreo(res.usuario?.correo);

        if (res.casillero?.codigo) {
          setCasilleroCodigo(res.casillero.codigo);
          localStorage.setItem('casilleroCodigo', res.casillero.codigo);
        }
      } catch (err) {
        console.error('[APP] ❌ Token inválido o expirado:', err.response?.data || err.message);
        logout();
        setRol(null);
        setCorreo(null);
        setCasilleroCodigo(null);
      } finally {
        setLoading(false);
      }
    };

    validarSesion();
  }, []);

  const handleLogout = () => {
    logout();
    setRol(null);
    setCorreo(null);
    setCasilleroCodigo(null);
    window.location.href = '/';
  };

  if (loading) {
    return <Typography sx={{ mt: 4, textAlign: 'center' }}>Cargando sesión...</Typography>;
  }

  return (
    <Router>
      <MainLayout
        rol={rol}
        correo={correo}
        casilleroCodigo={casilleroCodigo}
        onLogout={handleLogout}
        onLogin={(r, c, cas) => {
          localStorage.setItem('rol', r);
          localStorage.setItem('correo', c);
          if (cas) localStorage.setItem('casilleroCodigo', cas);
          setRol(r);
          setCorreo(c);
          setCasilleroCodigo(cas || null);
        }}
      />
    </Router>
  );
}

function MainLayout({ rol, correo, casilleroCodigo, onLogout, onLogin }) {
  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            🚚 ProSM Logistic - LoginTrack
          </Typography>

          <Button color="inherit" component={Link} to="/">Home</Button>

          {!rol && (
            <>
              <Button color="inherit" component={Link} to="/login">Login</Button>
              <Button color="inherit" component={Link} to="/register">Crea tu casillero</Button>
            </>
          )}

          {(rol === 'admin' || rol === 'superadmin') && (
            <Button color="inherit" component={Link} to="/dashboard">Dashboard</Button>
          )}

          {rol === 'superadmin' && (
            <Button color="inherit" component={Link} to="/create-admin">Crear Admin</Button>
          )}

          {rol === 'cliente' && (
            <Button color="inherit" component={Link} to="/consulta">Consulta Envío</Button>
          )}

          {rol && (
            <Button color="inherit" onClick={onLogout}>Logout</Button>
          )}
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login onLogin={onLogin} />} />
          <Route path="/register" element={<CrearCasillero onRegister={onLogin} />} />
          <Route path="/create-admin" element={rol === 'superadmin' ? <CreateAdmin /> : <Navigate to="/login" />} />
          <Route path="/dashboard" element={rol === 'admin' || rol === 'superadmin' ? <UserDashboard /> : <Navigate to="/login" />} />
          <Route path="/consulta" element={rol === 'cliente' ? <ConsultaEnvio casilleroCodigo={casilleroCodigo} /> : <Navigate to="/login" />} />
          <Route path="*" element={<Typography>404 - Página no encontrada</Typography>} />
        </Routes>
      </Container>
    </>
  );
}

export default App;